<template>
  <v-container fluid
    ><h2>{{ $t("app.visit.greeting") }}</h2>
    <form
      v-if="!visit"
      action
      @submit.prevent="submitForm(!editId ? 'add' : 'edit')"
    >
      <h4>{{ $t("app.visit.intro") }}</h4>
      <div class="error" v-if="error">
        <p>{{ error }}</p>
      </div>

      <div class="field">
        <InputField
          v-model="form.date"
          :labelTitle="$t('app.visit.form-date')"
          required
          type="date"
          margin="25px auto"
        ></InputField>

        <InputField
          v-model="form.time"
          :labelTitle="$t('app.visit.form-time')"
          type="time"
          step="60"
          required
          placeholder="14:00"
          margin="25px auto"
          unit-icon="clock-pink"
          unit-first
        ></InputField>

        <InputField
          v-model="form.extra"
          :labelTitle="$t('app.visit.form-extra')"
          :placeholder="$t('app.visit.form-extra-placeholder')"
          margin="25px auto"
        ></InputField>

        <TextAreaField
          rows="3"
          v-model="form.remark"
          :labelTitle="$t('app.visit.form-remark')"
          :placeholder="$t('app.visit.form-remark-placeholder')"
          margin="0 auto 25px auto"
        ></TextAreaField>

        <LoadingButton v-if="loading"></LoadingButton>
        <Button
          v-else
          type="submit"
          :title="$t('app.visit.action-send')"
        ></Button>

        <div id="request-success">
          <div class="success-checkmark">
            <div id="check-icon">
              <span class="icon-line line-tip"></span>
              <span class="icon-line line-long"></span>
              <div class="icon-circle"></div>
              <div class="icon-fix"></div>
            </div>
          </div>
          <div v-if="success">
            <p>{{ success }}</p>
          </div>
        </div>
      </div>
    </form>
    <div v-else class="planned-visit">
      <div v-if="visit.message && visit.message.trim().length > 0 && visit.nurse" class="visit-message">
        <h4 class="pink--text">
          {{ $t("app.visit.message.title") }} {{ visit.nurse.nickName }}:
        </h4>
        <p v-if="!showTranslation">"{{ visit.message }}"</p>
        <p v-if="showTranslation">"{{ translation }}"</p>
        <div class="bottom" v-if="!visit.messageRead">
          <p>
            {{ $t("app.visit.message.mark-read") }}
          </p>
          <Button
            :title="$t('app.visit.message.yes')"
            shadow="true"
            @click.native="markAsRead(true)"
            margin="0 0.5rem 1rem 0.5rem"
          ></Button>
          <Button
            :title="$t('app.visit.message.no')"
            shadow="true"
            @click.native="markAsRead(false)"
            margin="0 0.5rem 1rem 0.5rem"
            bgcolor="transparent"
            border="1px solid #e57378"
            color="#e57378"
          ></Button>
          <Button
            @click.native="toggleTranslation()"
            v-if="userHasTranslation"
            title
            shadow="true"
            color="#00A9B3"
            :bgcolor="showTranslation ? '#F3BDBF' : '#D9F0EA'"
            margin="0 0.5rem 1rem 0.5rem"
            padding="1"
            icon="translate"
          ></Button>
        </div>
        <div class="bottom" v-if="visit.messageRead">
          <Button
            @click.native="toggleTranslation()"
            v-if="userHasTranslation"
            title
            shadow="true"
            color="#00A9B3"
            :bgcolor="showTranslation ? '#F3BDBF' : '#D9F0EA'"
            margin="0 0.5rem 1rem 0.5rem"
            padding="1"
            icon="translate"
          ></Button>
        </div>
      </div>
      <p>
        <span class="read-confirmation" v-if="visit.nurse">
          ({{ `${$t("app.visit.seen")} ${visit.nurse.nickName}` }})
        </span>
        <span class="read-confirmation" v-else>
          ({{ $t("app.visit.not-seen") }})
        </span>
        {{ $t("app.visit.planned") }}
      </p>
      <img :src="require('@/assets/icons/clock-blue.svg')" alt="Clock image" style="max-height: 60px; max-width: 60px; margin-top: 5px; margin-bottom: 5px"/>
      <span class="date">{{ visit.dateTime | moment("DD MMM YYYY") }}</span>
      <div>
        <span class="time">{{ visit.dateTime | moment("HH:mm") }}</span>
        <Button
          class="edit-visit-button"
          color="#00A9B3"
          bgcolor="transparent"
          width="30px"
          margin="10px 5px"
          padding="0"
          icon="pen-pink"
          @click.native="$modal.show('visit-menu-modal')"
        ></Button>

        <modal
          class="menu"
          :name="'visit-menu-modal'"
          width="100%"
          height="auto"
        >
          <ListItem
            border="1px solid #31b9be"
            @click.native="
              $modal.hide('visit-menu-modal');
              editVisit();
            "
            >{{ $t("app.visit.edit") }}</ListItem
          >
          <ListItem
            last="true"
            border="1px solid #31b9be"
            @click.native="
              $modal.hide('visit-menu-modal');
              deleteVisit();
            "
            >{{ $t("app.visit.delete") }}</ListItem
          >
        </modal>
      </div>
      <div v-if="visit.activities && visit.activities.length > 0" class="mt-4">
        <h4 class="pink--text">{{ $t("app.visit.activities") }}</h4>
        <ul class="tasks">
          <li v-for="activity in visit.activities" :key="activity.id">
            {{ activity.label }}
          </li>
        </ul>
    </div>
    </div>
  </v-container>
</template>

<script>
import { getNotifications } from "@/helpers";
import {neoparentPosts, neoparentVisits} from "@/api";

export default {
  name: "neoparent-visit",
  props: [],
  data() {
    return {
      loading: false,
      error: "",
      enableTranslation: false,
      showTranslation: false,
      translation: null,
      form: {
        date: "",
        time: "",
        extra: "",
        remark: ""
      },
      success: "",
      editId: null,
      visit: null
    };
  },
  mounted() {
    this.enableTranslation = this.$store.getters.user.hospital.hasDeepl;
    this.getVisits();
    // getNotifications();
  },
  computed: {
    userHasTranslation() {
      return this.enableTranslation && (this.$store.getters.user.translationLanguage || this.$store.getters.user.role !== 'p');
    }
  },
  methods: {
    async toggleTranslation(postId) {
      this.showTranslation = !this.showTranslation;
      if (!this.translation && this.showTranslation) {
        const res = await neoparentVisits.translateComment(this.visit.id);
        this.translation = res.data.translation;
      }
    },
    getVisits() {
      neoparentVisits
        .getLatestVisitForPatient(this.$store.getters.user.patient.id)
        .then(result => {
          this.visit = result.data.visit;
        })
        .catch(err => {
          this.consoleLog(err);
        });
    },
    submitForm(action) {
      if (action !== "add" && action !== "edit") return;
      let datetime = new Date(this.form.date);
      datetime.setHours(this.form.time.split(":")[0]);
      datetime.setMinutes(this.form.time.split(":")[1]);

      // Check if date is not in the past
      if (datetime > new Date()) {
        this.loading = true;
        let data = {
          datetime: datetime,
          extra: this.form.extra ? this.form.extra : null,
          remark: this.form.remark ? this.form.remark : null,
          patient: this.$store.getters.user.patient,
          user: this.$store.getters.user
        };

        this.consoleLog(data);

        if (action === "add") {
          // Create new
          this.consoleLog("Creating visit");
          neoparentVisits
            .addVisit(data)
            .then(result => {
              this.consoleLog(result);
              this.displaySucces(datetime, result.data.visit);
            })
            .catch(err => {
              this.error = err.response.data.message;
              this.consoleLog(err);
            });
        } else {
          // Edit visit
          this.consoleLog("Updating visit");
          data.id = this.editId;
          neoparentVisits
            .editVisit(this.editId, data)
            .then(result => {
              this.consoleLog(result);
              this.displaySucces(datetime, result.data.visit)
            })
            .catch(err => {
              this.error = err.response.data.message;
              this.consoleLog(err);
            });
        }
      } else {
        this.error = this.$t("error.visit.past");
      }
      this.loading = false;
      window.scrollTo(0, 0);
    },
    editVisit() {
      this.form.date = this.$moment(this.visit.dateTime).format("YYYY-MM-DD");
      this.form.time = this.$moment(this.visit.dateTime).format("HH:mm");
      this.form.extra = this.visit.extra || "";
      this.form.remark = this.visit.remark || "";
      this.editId = this.visit.id;
      this.visit = null;
    },
    deleteVisit() {
      if (confirm(this.$t("app.visit.confirm"))) {
        neoparentVisits
          .deleteVisit(this.visit.id)
          .then(result => {
            this.consoleLog(result);
            this.form.date = "";
            this.form.time = "";
            this.form.extra = "";
            this.form.remark = "";
            this.visit = null;
            this.editId = null
          })
          .catch(err => {
            this.consoleLog(err);
            this.error = err.response.data.message;
            window.scrollTo(0, 0);
          });
      }
    },
    displaySucces(datetime, visit) {
      // Animation success
      document.getElementById("request-success").style.display = "block";
      this.success = this.$t("success.visit-sent");
      setTimeout(() => {
        window.location.href = "/"

/*        document.getElementById("request-success").style.display = "none";
        this.visit = visit
        this.loading = false;
        this.error = null;*/
      }, 3000);
    },
    markAsRead(read) {
      if (read === false){
        window.location.href = '/'
      } else {
        neoparentVisits.markCommentRead(this.visit.id)
          .then(() => {
            this.visit.messageRead = true
          })
      }
    }
  }
};
</script>

<style scoped lang="scss">
form {
  position: relative;
}

.planned-visit {
  width: 90%;
  margin: 0 auto 5rem auto;

  .read-confirmation {
    display: block;
    font-style: italic;
  }
}

.planned-visit img {
  margin: -2rem 0;
  width: 75%;
}

.edit-visit-button {
  position: absolute;
}

.date {
  display: block;
}

.time {
  font-size: 48px;
}

.visit-message {
  // margin-bottom: 5rem;

  * {
    margin: 0.5rem;
  }
}
.tasks {
  list-style-type: none;

  li {
    word-break: break-all;
    display: list-item;
    margin-left: 1rem;
    cursor: pointer;
    user-select: none;
    padding: 0.3rem 0;

    .content {
      width: 100%;
      display: inline-flex;
      justify-content: space-between;

      & .delete {
        font-weight: bold;
      }
    }

    &.done .label {
      opacity: 0.5;
      text-decoration: line-through;
    }

    &::before {
      content: ">";
      color: #e05484;
      font-weight: bold;
      display: inline-block;
      width: 1rem;
      margin-left: -1rem;
    }

    &.add {
      display: flex;
      align-items: center;
      margin-top: 1rem;

      .v-select {
        width: 90%;
      }

      &::before {
        content: "+";
      }
    }
  }
}

</style>
